import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IKIOSKModel } from '../../../../models/kioskModel2';
import { Ilanguages } from '../../../../models/utilitiesModel';

const ThankYoupage: React.FC = () => {
    const { t } = useTranslation("translations");
    const language: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG);
    const authFailMessage: string = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.authFailMessage || "");
    console.log("checkauthmessage=>", authFailMessage);
    return (
        <div className='d-flex flex-column align-items-center gap-4 thank_msg'>
            <i className='icon_m42kiosk_registration_desk'></i>
            {authFailMessage === 'EM0' && <span>{t('errorMessage.EM1' + language)}<br /> {t('errorMessage.EM2' + language)}</span>}
            {authFailMessage !== 'EM0' && <p>{authFailMessage + language}</p>}
            <span style={{marginTop: "90px"}}>{t("kiosktranslation.thankYou")}</span>
        </div>
    );
}

export default React.memo(ThankYoupage);